import React from 'react'

import PaidAdvertisement from 'components/paid-advertisement'
import AdvertiserDisclosure from 'components/advertiser-disclosure'

import styles from '../styles.module.scss'

const FoxAboveCta = () => {
  return (
    <div className={styles.disclosuresWrap}>
      <AdvertiserDisclosure contentClassName={styles.tooltipContentRich} />
      <PaidAdvertisement />
    </div>
  )
}

export default FoxAboveCta
